<nav>
  <ng-container *ngFor="let tab of enabledTabs; let tabIndex = index">
    <a
      *ngIf="
        !!media &&
        (media.mediaLinkedType !== 3 ||
          (media.mediaLinkedType === 3 &&
            tab.title !== 'Files' &&
            tab.title !== 'Position'))
      "
      (click)="onTabClick(tab)"
      class="active"
      [ngClass]="{ active: isTabSelected(tab) }"
    >
      <span
        *ngIf="tab.title === 'QC Status'"
        class="tab-dot"
        [ngStyle]="{ 'background-color': getQCStatusTabDotColor() }"
      ></span
      >{{ tab.title }}
    </a>
  </ng-container>
</nav>

<div class="container">
  <h4>{{ title }}</h4>
  <ul class="tabs-wrapper">
    <li [hidden]="activeTab != 0">
      <section>
        <ichannel-input
          [label]="'Video Title'"
          [value]="media?.name"
          (output)="setMediaName($event)"
          [placeholder]="'Enter Video Title'"
        ></ichannel-input>

        <div class="tenant-media-id-container">
          <div class="video-id-icons">
            <evrideo-copy-button
              class="copy-button"
              *ngIf="media"
              [ngClass]="{
                hidden:
                  !media ||
                  !media.tenantMediaId ||
                  media.tenantMediaId.length === 0,
              }"
              [hoverClass]="'black'"
              [copy-clipboard]="media.tenantMediaId"
              (copied)="showToastr('VIDEO ID has been copied!')"
            ></evrideo-copy-button>
            <circle-indicator
              [status]="getTenantMediaIdAnalyzingStatus()"
            ></circle-indicator>
          </div>
          <ichannel-input
            #tenantMediaIdInput
            [label]="'Video ID'"
            [value]="media?.tenantMediaId"
            class="tenantMediaIdInput"
            (output)="setVideoId($event)"
            [placeholder]="'Enter Video ID'"
          ></ichannel-input>
        </div>

        <ichannel-textarea
          [label]="'Description'"
          [value]="media?.description"
          (output)="setMediaDesc($event)"
          [placeholder]="'Enter Video Description'"
          [maxLength]="400"
        ></ichannel-textarea>

        <ichannel-dropdown
          [label]="'Asset Type'"
          [key]="'title'"
          [placeholder]="'Select Asset Type'"
          [options]="assetTypeOptions"
          [initValue]="media ? media['AssetType'] : undefined"
          [multiple]="true"
          (output)="setAssetType($event)"
        ></ichannel-dropdown>
        <div>
          <a *ngIf="media" href="" (click)="downloadMediaUsageReport()"
            >Download Media Usage Report</a
          >
        </div>
      </section>

      <section class="divider"></section>

      <section>
        <ichannel-dropdown
          [label]="'DayParting'"
          [key]="'title'"
          [placeholder]="'Select Day Part'"
          [options]="dayPartOptions"
          [initValue]="media ? media['DaypartType'] : undefined"
          (output)="setDayparting($event)"
        ></ichannel-dropdown>

        <autocomplete
          [inputLabel]="'TAGS'"
          [inputPlaceholder]="'Add Tags'"
          [feedWithEnter]="false"
          [values]="availableTags"
          [excludes]="(media && media.tags) || []"
          [key]="'name'"
          [visible]="false"
          (output)="addNewTag($event)"
          (outputNewValue)="createNewTag($event)"
        ></autocomplete>
        <tags-wrapper
          [tags]="(media && media.tags) || []"
          (onDeleteTag)="deleteExistTag($event)"
        ></tags-wrapper>

        <div class="frame-format-container">
          <label class="frame-format-label">Frame Format</label>
          <icn-dropdown
            class="frame-format-dropdown"
            (selectedValueChange)="media.frameFormat = $event"
            [selectedValue]="media ? media.frameFormat : 0"
          >
            <icn-dropdown-item
              [title]="'Unknown'"
              [value]="0"
            ></icn-dropdown-item>
            <icn-dropdown-item
              [title]="'Progressive'"
              [value]="1"
            ></icn-dropdown-item>
            <icn-dropdown-item
              [title]="'Top Field First'"
              [value]="2"
            ></icn-dropdown-item>
            <icn-dropdown-item
              [title]="'Bottom Field First'"
              [value]="3"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
        <div class="start-timestamp-ms">
          <label class="start-timestamp-ms-field">START TIMECODE</label>

          <evrideo-time-editor
            *ngIf="media"
            [(valueMs)]="media.startTimeStampMs"
            [fontSize]="'22px'"
            [height]="'26px'"
            [minMs]="0"
            [fullMode]="true"
            [frameRate]="media.contentFps"
            [type]="timecodeEditorType"
          ></evrideo-time-editor>
        </div>
        <evrideo-crop-settings-editor
          *ngIf="this.media && this.media.cropSettings"
          [cropSettings]="media.cropSettings"
          (valueUpdated)="updateQCCMarkBox()"
        ></evrideo-crop-settings-editor>
        <ul>
          <li>
            <button>
              <svg width="19px" height="18px">
                <path
                  fill-rule="evenodd"
                  d="M17.166,17.999 L1.833,17.999 C0.825,17.999 -0.001,17.175 -0.001,16.166 L-0.001,4.833 C-0.001,3.824 0.825,3.000 1.833,3.000 L5.500,3.000 L6.999,-0.001 L11.999,-0.001 L13.500,3.000 L17.166,3.000 C18.174,3.000 18.999,3.824 18.999,4.833 L18.999,16.166 C18.999,17.175 18.174,17.999 17.166,17.999 ZM18.000,4.833 C18.000,4.373 17.626,4.000 17.166,4.000 L13.500,4.000 L12.881,4.000 L12.605,3.447 L11.381,1.000 L7.617,1.000 L6.394,3.447 L6.117,4.000 L5.500,4.000 L1.833,4.000 C1.373,4.000 0.999,4.373 0.999,4.833 L0.999,16.166 C0.999,16.626 1.373,17.000 1.833,17.000 L17.166,17.000 C17.626,17.000 18.000,16.626 18.000,16.166 L18.000,4.833 ZM9.500,15.082 C6.972,15.082 4.916,13.027 4.916,10.499 C4.916,7.972 6.972,5.916 9.500,5.916 C12.027,5.916 14.083,7.972 14.083,10.499 C14.083,13.027 12.027,15.082 9.500,15.082 ZM9.500,6.917 C7.523,6.917 5.916,8.524 5.916,10.499 C5.916,12.475 7.523,14.083 9.500,14.083 C11.475,14.083 13.083,12.475 13.083,10.499 C13.083,8.524 11.475,6.917 9.500,6.917 Z"
                />
              </svg>
              <span>Upload A Packshot</span>
            </button>

            <div
              class="thumbnail"
              style="
                background-image: url(&quot;https://s3-eu-west-1.amazonaws.com/icuploadsdev/thumb/thumb_0e6df587-cec1-e611-8149-06ab531532a5.png&quot;);
              "
            ></div>
          </li>
          <li>
            <button>
              <svg width="19px" height="18px">
                <path
                  fill-rule="evenodd"
                  d="M17.288,18.000 L1.711,18.000 C0.770,18.000 -0.001,17.229 -0.001,16.288 L-0.001,1.711 C-0.001,0.770 0.770,-0.000 1.711,-0.000 L17.288,-0.000 C18.229,-0.000 18.999,0.770 18.999,1.711 L18.999,16.288 C18.999,17.229 18.229,18.000 17.288,18.000 ZM18.000,1.711 C18.000,1.319 17.680,1.000 17.288,1.000 L1.711,1.000 C1.319,1.000 0.999,1.319 0.999,1.711 L0.999,16.288 C0.999,16.680 1.319,16.999 1.711,16.999 L17.288,16.999 C17.680,16.999 18.000,16.680 18.000,16.288 L18.000,1.711 ZM15.000,13.999 L15.999,13.999 L15.999,15.000 L15.000,15.000 L15.000,13.999 ZM15.000,3.000 L15.999,3.000 L15.999,4.000 L15.000,4.000 L15.000,3.000 ZM11.999,13.999 L12.999,13.999 L12.999,15.000 L11.999,15.000 L11.999,13.999 ZM6.999,6.000 L12.999,9.000 L6.999,12.000 L6.999,6.000 ZM11.999,3.000 L12.999,3.000 L12.999,4.000 L11.999,4.000 L11.999,3.000 ZM8.999,3.000 L9.999,3.000 L9.999,4.000 L8.999,4.000 L8.999,3.000 ZM5.999,3.000 L6.999,3.000 L6.999,4.000 L5.999,4.000 L5.999,3.000 ZM2.999,13.999 L3.999,13.999 L3.999,15.000 L2.999,15.000 L2.999,13.999 ZM2.999,3.000 L3.999,3.000 L3.999,4.000 L2.999,4.000 L2.999,3.000 ZM6.999,15.000 L5.999,15.000 L5.999,13.999 L6.999,13.999 L6.999,15.000 ZM9.999,15.000 L8.999,15.000 L8.999,13.999 L9.999,13.999 L9.999,15.000 Z"
                />
              </svg>
              <span>Upload A 3sec Trailer</span>
            </button>

            <div
              class="thumbnail"
              style="
                background-image: url(&quot;https://s3-eu-west-1.amazonaws.com/icuploadsdev/thumb/thumb_0e6df587-cec1-e611-8149-06ab531532a5.png&quot;);
              "
            ></div>
          </li>
        </ul>
      </section>
    </li>
    <li class="meta-data-tab" [hidden]="activeTab != 1">
      <div class="meta-data-header">
        <h4>Video Meta Data:</h4>
        <icn-dropdown
          [position]="'bottom'"
          [selectedValue]="metadataLanguage"
          [disabled]="metadataLanguageCodes.length === 0"
          (selectedValueChange)="onMetadataLanguageChanged($event)"
        >
          <icn-dropdown-item
            *ngFor="let item of metadataLanguageDropdownItems"
            [title]="item.title"
            [value]="item.value"
          >
          </icn-dropdown-item>
        </icn-dropdown>
        <label class="change-meta-data-language-label"
          >CHANGE METADATA LANGUAGE:</label
        >
      </div>
      <div class="meta-data-body">
        <div class="left-meta-data-body">
          <ng-template
            ngFor
            let-originalIndex
            let-i="index"
            [ngForOf]="visibleMetadataIndices"
          >
            <ichannel-input
              *ngIf="i % 2 === 0"
              [label]="userMetadata[originalIndex].name"
              [value]="metadataValue(originalIndex)"
              (output)="setMetadataValue($event, originalIndex)"
              [placeholder]="'Hint Text'"
            >
            </ichannel-input>
          </ng-template>
        </div>
        <div class="right-meta-data-body">
          <ng-template
            ngFor
            let-originalIndex
            let-i="index"
            [ngForOf]="visibleMetadataIndices"
          >
            <ichannel-input
              *ngIf="i % 2 != 0"
              [label]="userMetadata[originalIndex].name"
              [value]="metadataValue(originalIndex)"
              (output)="setMetadataValue($event, originalIndex)"
              [placeholder]="'Hint Text'"
            >
            </ichannel-input>
          </ng-template>
        </div>
      </div>
    </li>

    <li [hidden]="activeTab != 2">
      <section>
        <evrideo-media-segments
          *ngIf="mediaSegmentsViewModel"
          [vm]="mediaSegmentsViewModel"
        ></evrideo-media-segments>
      </section>
    </li>

    <li
      *ngIf="!!media ? !(media.mediaLinkedType === 3) : false"
      [hidden]="activeTab !== 4"
    >
      <section>
        <p>Item position for use in secondary events:</p>
        <div>
          <evrideo-graphics-rectangle-f
            *ngIf="!!media && !!floatingMediaPositionRectangleVM"
            [vm]="floatingMediaPositionRectangleVM"
          ></evrideo-graphics-rectangle-f>
        </div>
        <div class="floating-media-depth">
          <evrideo-layer-input
            *ngIf="!!media"
            [(zIndex)]="media.floatingMediaDepth"
            [showTooltip]="false"
          ></evrideo-layer-input>
        </div>
        <div class="media-should-squeeze-container">
          <input
            type="checkbox"
            [checked]="media.mediaShouldSqueeze"
            (change)="media.mediaShouldSqueeze = $any($event.target).checked"
          />
          <label>Media Should Squeeze the screen?</label>
        </div>
      </section>
    </li>
    <li
      *ngIf="!!media ? !(media.mediaLinkedType === 3) : false"
      [hidden]="activeTab !== 3"
    >
      <section>
        <icn-edit-media-files-tab
          [media]="media"
          (audioLangChanged)="canSave()"
        ></icn-edit-media-files-tab>
      </section>
    </li>
    <li [hidden]="activeTab != 5" class="license-wrapper">
      <section>
        <div>
          <label>Approved Countries</label>
          <icn-dropdown
            [placeholder]="'Select Country'"
            [allowMultiple]="true"
            [position]="'bottom'"
            [returnItems]="true"
            [selectedValues]="countries"
            (selectedValuesChange)="onCountrySelect($event)"
          >
            <icn-dropdown-item [title]="'All'" [value]="0"></icn-dropdown-item>
            <icn-dropdown-item
              *ngFor="let country of availableCountries"
              [title]="country.name"
              [value]="country.id"
            >
            </icn-dropdown-item>
          </icn-dropdown>
        </div>

        <div>
          <label>License Period</label>
          <ul>
            <li>
              <label>License From Date:</label>
              <dateinput
                [current]="
                  media && media.licenseFrom ? media.licenseFrom : null
                "
                [disabled]="true"
                (currentChange)="media.licenseFrom = $event"
              ></dateinput>
            </li>
            <li>
              <label>License To Date:</label>
              <dateinput
                [current]="media && media.licenseTo ? media.licenseTo : null"
                [disabled]="true"
                (currentChange)="media.licenseTo = $event"
              ></dateinput>
            </li>
          </ul>
        </div>
      </section>
    </li>
    <li [hidden]="activeTab != 6" class="qc-workflow-wrapper">
      <section>
        <div
          *ngIf="media?.mediaQCWorkflowObjectives.length > 0; else noObjectives"
        >
          <table class="qc-status-table">
            <thead>
              <tr>
                <th>Task</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let objective of mediaQCWorkflowObjectivesvm">
                <td [title]="objective.task">{{ objective.task }}</td>
                <td>
                  <select
                    [value]="objective.status"
                    (change)="
                      onQCWorkflowObjectiveStatusChange(
                        objective.objectiveId,
                        $event
                      )
                    "
                    [disabled]="saving"
                  >
                    <option
                      *ngFor="
                        let status of MediaQCWorkflowObjectiveStatusOptions
                      "
                      [value]="status.value"
                      [selected]="objective.status === status.value"
                    >
                      {{ status.name }}
                    </option>
                  </select>
                </td>
                <td>
                  <ng-container
                    *ngIf="objective.userId && objective.updatedDate"
                  >
                    status updated by <strong>{{ objective.userId }}</strong> on
                    {{ objective.updatedDate | date: "yyyy/MM/dd" }}
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noObjectives>
          <p>No QC workflow objectives found</p>
          <ichannel-button
            [label]="
              !generatingQCObjectives
                ? 'Add QC Workflow Objective to this media'
                : 'Adding objectives...'
            "
            [theme]="'DARK'"
            [callback]="addQCWorkflowObjective.bind(this)"
          ></ichannel-button>
        </ng-template>
      </section>
    </li>
  </ul>
</div>
<footer>
  <div>
    <ichannel-button [label]="'Cancel'" [callback]="reset()"></ichannel-button>
    <ichannel-button
      [label]="saving ? 'Saving...' : 'Save'"
      [theme]="_canSave ? 'DARK' : 'DIS'"
      [callback]="onSave()"
    ></ichannel-button>
  </div>
</footer>
